export default "__VITE_ASSET__x8psZs8M__"